module.exports = __webpack_public_path__ + "img/new_fashion.d419353b.svg";